import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@shared/models/api-response";
import { SearchCriteria } from "@shared/models/search-criteria";
import { environment } from "environments/environment";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
    vibrationAPI = environment.vibrationApiURL;
  constructor(private httpClient: HttpClient) { }
  
  public getMonitoringDevices(searchCriteria: SearchCriteria): Observable<any> {
    const params = new HttpParams({ fromObject: searchCriteria as any });
    return this.httpClient.get<any>(`${this.vibrationAPI}/Monitoring/devices`, {params});
  }

  public getMonitoringDevice(searchCriteria: SearchCriteria): Observable<any> {
    const params = new HttpParams({ fromObject: searchCriteria as any });
    
    return this.httpClient.get<any>(
      `${this.vibrationAPI}/Monitoring/device`, { params }
    );
  }

getMonitoringDeviceNames(): Observable<any> {
    return this.httpClient
      .get<ApiResponse<any>>(
        `${this.vibrationAPI}/Monitoring/devices-names`
      )
      .pipe(
        map(response => response.data)
      );
  }

  public getCalendarSummary(searchCriteria: {
    startDate: string;
    endDate: string;
    deviceId?: number[];
  }): Observable<any> {
    let params = new HttpParams()
      .set('startDate', searchCriteria.startDate)
      .set('endDate', searchCriteria.endDate);

    (searchCriteria.deviceId ?? []).forEach(deviceId => {
      params = params.append('deviceId', deviceId);
    });

    return this.httpClient.get<ApiResponse<any>>(
      `${this.vibrationAPI}/seismographs/calendar-summary`,
      { params }
    ).pipe(
      map(response => response.data)
    );
  }

  public getRecordIdBySerialAndTimestamp(siteId: number, serialNumber: string, timestamp: Date): Observable<any> {
    // Formater la date en local time string ISO (YYYY-MM-DDTHH:mm:ss)
    const year = timestamp.getFullYear();
    const month = String(timestamp.getMonth() + 1).padStart(2, '0');
    const day = String(timestamp.getDate()).padStart(2, '0');
    const hours = String(timestamp.getHours()).padStart(2, '0');
    const minutes = String(timestamp.getMinutes()).padStart(2, '0');
    const seconds = String(timestamp.getSeconds()).padStart(2, '0');
    const localTimestamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    const params = new HttpParams({
      fromObject: {
        serialNumber: serialNumber,
        timestamp: localTimestamp
      }
    });
    
    return this.httpClient.get<ApiResponse<number>>(
      `${this.vibrationAPI}/sites/${siteId}/vibration-records/record-id`,
      { params }
    ).pipe(
      map(response => response.data)
    );
  }
  
}